var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"bmv-collapse"},on:{"before-enter":_vm.onBeforeEnter,"enter":_vm.onEnter,"before-leave":_vm.onBeforeLeave,"leave":_vm.onLeave}},[(_vm.open)?_c('div',{staticClass:"bmv-collapse"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }